import React from 'react'
import style from './summary.module.scss'
import { PaymentInfo } from './paymentInfo/PaymentInfo'
import { AmountCard } from './amountCard/AmountCard'

/**
 * It contains 2 components, in the left PaymentInfo and in the right AmountCard
 */
export const PureSummary = ({ children }) => {
	return (
		<div className={style.summary}>
			<div className={style.container}>{children}</div>
		</div>
	)
}

export const Summary = () => {
	return (
		<PureSummary>
			<PaymentInfo />
			<AmountCard />
		</PureSummary>
	)
}
